import { message } from 'antd';

import { select, call, put, takeEvery, takeLatest, all, fork } from 'redux-saga/effects'
import { INTEGRATOR_AUTHORIZED_ROLES, PREREAD_ROLES } from '../../constants/constants';
import { isIntegratorRunningAPI, createSessionIdAPI, loadUnloadOrderAPI, closeSessionAPI, getPacsSessionIdAPI, getPacsListAPI } from '../../services/integrator-service';

import { CLOSE_SESSION, CLOSE_SESSION_ERROR, CLOSE_SESSION_START, CLOSE_SESSION_SUCCESS, FETCH_INTEGRATOR, FETCH_INTEGRATOR_ERROR, FETCH_INTEGRATOR_START, FETCH_INTEGRATOR_SUCCESS, generateSessionID, GENERATE_SESSIONID, GENERATE_SESSIONID_ERROR, GENERATE_SESSIONID_START, GENERATE_SESSIONID_SUCCESS, LOAD_ORDER, LOAD_ORDER_ERROR, LOAD_ORDER_START, LOAD_ORDER_SUCCESS, UNLOAD_ORDER, UNLOAD_ORDER_ERROR, UNLOAD_ORDER_START, UNLOAD_ORDER_SUCCESS, FETCH_PACS_SUCCESS, FETCH_PACS_ERROR, FETCH_PACS_START, FETCH_PACS, SET_MIPS_PACS, fetchPacs } from '../actions/integratorActions';

const getAuthUserState = (state) => state.auth.authUser;
// const getRisUsersState = (state) => state.auth.authUser.risUserMips;
const getIntegratorState = (state) => state.integrator;

// function* getRisUserNameForRisId(risId, role) {
//     try {
//             const risUsers = yield select(getRisUsersState);
//             if (risUsers.length > 0) {
//                 const risUser = risUsers.find(user => user.risId === risId);
//                 if (risUser) {
//                     return risUser.userName;
//                 }
//                 message.error("Ris user not found for ris id:" + risId);
//                 return null;
//             }
//             message.error("Ris users not found!");
//             return null;
        
//     } catch (error) {
//         console.log(error);
//     }
// }

function* fetchPacsList({}){
    try {
        yield put({ type: FETCH_PACS_START });
        const response = yield getPacsListAPI();
        if(response.success){
            yield put({ type: FETCH_PACS_SUCCESS, pacs: response.data });
        } else {
            yield put({ type: FETCH_PACS_ERROR });
        }
    } catch (error) {
        yield put({ type: FETCH_PACS_ERROR, error })
        message.error('Failed to fetch pacs info!');
    }
}

function* fetchIntegrator({ }) {
    try {
        // fetch pacsList
        const pacsListResponse = yield getPacsListAPI();
        if(pacsListResponse.success){
            yield put({ type: FETCH_PACS_SUCCESS, pacs: pacsListResponse.data });
        } else {
            yield put({ type: FETCH_PACS_ERROR });
        }

        const authUser = yield select(getAuthUserState);
        if (authUser) {
            const { role, risUserMips } = authUser;
            const currentRole = role.replace("ROLE_", "");
            if (INTEGRATOR_AUTHORIZED_ROLES.includes(currentRole)) {
                yield put({ type: FETCH_INTEGRATOR_START })
                const response = yield isIntegratorRunningAPI();
                if (response) {
                    const integrator = yield select(getIntegratorState);
                    const risPacsList = [];
                    let mipPacs = {};
                    for (let index = 0; index < risUserMips.length; index++) {
                        const risUserMip = risUserMips[index];
                        const risPacs = { 
                            risUserId: risUserMip.risUserId, 
                            userId: risUserMip.userId, 
                            risId: risUserMip.risId, 
                            risName: risUserMip.risName, 
                            risCode: risUserMip.risCode, 
                            userName: risUserMip.userName, 
                            pacsId: risUserMip.pacsId
                        }
                        risPacsList.push(risPacs);
                        risUserMip.userMips.forEach(userMip => {
                            if(userMip.pacsId){
                                const existingRisPacs = risPacsList.find(risPacs => risPacs.pacsId === userMip.pacsId);
                                if(!existingRisPacs){
                                    risPacsList.push({ ...risPacs, pacsId: userMip.pacsId });
                                }
                                 mipPacs[userMip.mipId] = userMip.pacsId;
                            }
                        });
                    }

                    // const risUser = risUserMips.find(risUser => risUser.risName === "COMRAD" && risUser.risCode === "IWI");
                    // let risUser;
                    //     risUser = risUserMips.length > 0 ? risUserMips[0] : null;
                    // if (risUser) {
                    //     const pacsSessionId = sessionStorage.getItem("pacsSessionId");
                    //     if(pacsSessionId && pacsSessionId !==""){
                    //         yield put({ type: GENERATE_SESSIONID_SUCCESS, pacsSessionId })
                    //     }else{
                    //         yield put(generateSessionID(risUser));
                    //     }
                    // }
                    console.log("risPacsList:::", risPacsList);
                    for (let index = 0; index < risPacsList.length; index++) {
                        const risUser = risPacsList[index];
                        const pacsInfo = integrator.pacsList.find(pacs=> pacs.pacsId === risUser.pacsId);
                        const pacsSessionId = sessionStorage.getItem("pacsSessionId_"+ risUser.pacsId);
                        if(pacsSessionId && pacsSessionId !==""){
                            yield put({ type: GENERATE_SESSIONID_SUCCESS, pacsSession: { ...pacsInfo, pacsId: risUser.pacsId, pacsSessionId, risUser } })
                        }else{
                            // yield put(generateSessionID(risUser));
                            const response = yield getPacsSessionIdAPI(risUser.pacsId, risUser.userName, risUser.userName, risUser.userName);
                            if (response.success) {
                                const pacsInfo = integrator.pacsList.find(pacs=> pacs.pacsId === risUser.pacsId);
                                sessionStorage.setItem("pacsSessionId_"+ risUser.pacsId, response.pacsSessionId);
                                yield put({ type: GENERATE_SESSIONID_SUCCESS, pacsSession: { ...pacsInfo, pacsId: risUser.pacsId, pacsSessionId: response.pacsSessionId, risUser } })
                            } else {
                                yield put({ type: GENERATE_SESSIONID_ERROR, message: 'Failed to generate sessionID!' })
                            }
                        }
                    }
                    yield put({ type: SET_MIPS_PACS, mipPacs })
                } else {
                    yield put({ type: FETCH_INTEGRATOR_ERROR, message: 'Failed to fetch integrator info!' })
                    message.error('Failed to fetch integrator info!');
                }
            }
        } else {
            message.warning('Auth user not found!');
        }
    } catch (error) {
        console.log("error", error);
        yield put({ type: FETCH_INTEGRATOR_ERROR, error })
        message.error('Failed to fetch integrator info!');
    }
}

function* generateSessionId({ risUser }) {
    try {
        yield put({ type: GENERATE_SESSIONID_START })
        if (risUser) {
            // const response = yield createSessionIdAPI(risUser.userName, risUser.userName, risUser.userName);
            // if (response) {
            //     yield put({ type: GENERATE_SESSIONID_SUCCESS, sessionCreated: true })
            // } else {
            //     yield put({ type: GENERATE_SESSIONID_ERROR, message: 'Failed to generate sessionID!' })
            // }
            const integrator = yield select(getIntegratorState);
            const response = yield getPacsSessionIdAPI(risUser.pacsId, risUser.userName, risUser.userName, risUser.userName);
            console.log("response", response);
            if (response.success) {
                const pacsInfo = integrator.pacsList.find(pacs=> pacs.pacsId === risUser.pacsId);
                sessionStorage.setItem("pacsSessionId_"+ risUser.pacsId, response.pacsSessionId);
                yield put({ type: GENERATE_SESSIONID_SUCCESS, pacsSession: { ...pacsInfo, pacsId: risUser.pacsId, pacsSessionId: response.pacsSessionId, risUser } })
            } else {
                yield put({ type: GENERATE_SESSIONID_ERROR, message: 'Failed to generate sessionID!' })
            }
        } else {
            message.warning('RisUser user not found!');
        }
    } catch (error) {
        console.log("error", error);
        yield put({ type: GENERATE_SESSIONID_ERROR, error })
        message.error('Failed to generate sessionID!');
    }
}

function* loadOrder({ payload }) {
    try {
        yield put({ type: LOAD_ORDER_START })
        const authUser = yield select(getAuthUserState);
        // const { role } = authUser;
        // const currentRole = role.replace("ROLE_", "");
        const { mipPacs, pacsSessions, pacsList } = yield select(getIntegratorState);
        
        const pacsId =  mipPacs[payload.mipId];
        let pacsSession;
        if(pacsId){
            pacsSession = pacsSessions.find(pacsSession => pacsSession.pacsId === pacsId);
        } else {
            pacsSession = pacsSessions.find(pacsSession => pacsSession.risUser.risId === payload.risId);
        }
        if(!pacsSession){
            console.log("Pacs session not found for pacsId: "+ pacsId + " mipId: " + payload.mipId + " risId: " + payload.risId);
            const pacsInfo = pacsList.find(pacs=> pacs.pacsId === pacsId);
            message.error(pacsInfo ? "Pacs session not found for " + pacsInfo.name : "No PACS is configured for this site.");
            yield put({ type: LOAD_ORDER_ERROR, message: 'Pacs session not found' })
            return;
        }

        if (authUser) {
            // const risUserName = yield getRisUserNameForRisId(payload.risId, currentRole);
            const data = {
                "baseURL": pacsSession.baseUrl,
                "patientId": payload.patientId,
                "accessionNum": payload.accessionNum,
                "sid":  pacsSession.pacsSessionId,
                "user": pacsSession.risUser.userName,
            }
            const response = yield loadUnloadOrderAPI(data);
            if (response) {
                const order = {
                    ...payload
                }
                yield put({ type: LOAD_ORDER_SUCCESS, order })
            } else {
                yield put({ type: LOAD_ORDER_ERROR, message: 'Failed to load order images!' })
            }
        } else {
            message.warning('Auth user not found!');
        }
    } catch (error) {
        yield put({ type: LOAD_ORDER_ERROR, error })
        message.error('Failed to load order images!');
    }
}

function* unloadOrder({ payload }) {
    try {
        yield put({ type: UNLOAD_ORDER_START })
        const authUser = yield select(getAuthUserState);
        // const { role } = authUser;
        // const currentRole = role.replace("ROLE_", "");
        const { mipPacs, pacsSessions, pacsList } = yield select(getIntegratorState);
        
        const pacsId =  mipPacs[payload.mipId];
        let pacsSession;
        if(pacsId){
            pacsSession = pacsSessions.find(pacsSession => pacsSession.pacsId === pacsId);
        } else {
            pacsSession = pacsSessions.find(pacsSession => pacsSession.risUser.risId === payload.risId);
        }
        if(!pacsSession){
            console.log("Pacs session not found for pacsId: "+ pacsId + " mipId: " + payload.mipId + " risId: " + payload.risId);
            return;
        }

        if (authUser) {
            // const risUserName = yield getRisUserNameForRisId(payload.risId, currentRole);
            const data = {
                "baseURL": pacsSession.baseUrl,
                "patientId": payload.patientId,
                "accessionNum": payload.accessionNum,
                "sid":  pacsSession.pacsSessionId,
                "user": pacsSession.risUser.userName,
                "close": ""
            }
            const response = yield loadUnloadOrderAPI(data);
            if (response) {
                yield put({ type: UNLOAD_ORDER_SUCCESS })
            } else {
                yield put({ type: UNLOAD_ORDER_ERROR, message: 'Failed to unload order!' })
            }
        } else {
            message.warning('Auth user not found!');
        }
    } catch (error) {
        yield put({ type: UNLOAD_ORDER_ERROR, error })
        message.error('Failed to unload order!');
    }
}

function* closeSession({ }) {
    try {
        yield put({ type: CLOSE_SESSION_START })
        const authUser = yield select(getAuthUserState);
        const integrator = yield select(getIntegratorState);
        if (authUser) {
            const { role, risUserMips } = authUser;
            if(!role){
                return;
            }
            const currentRole = role.replace("ROLE_", "");
            if (INTEGRATOR_AUTHORIZED_ROLES.includes(currentRole)) {
                // const risUser = risUserMips.find(risUser => risUser.risName === "RIS" && risUser.risCode === "PSPL");
                // const risUser = risUserMips.length > 0 ? risUserMips[0] : null;
                // if (risUser && integrator.pacsSessionId) {
                //     const response = yield closeSessionAPI(risUser.userName, integrator.pacsSessionId);
                //     if (response) {
                //         yield put({ type: CLOSE_SESSION_SUCCESS })
                //     } else {
                //         yield put({ type: CLOSE_SESSION_ERROR, message: 'Failed to close session!' })
                //     }
                // }
                // sessionStorage.removeItem("pacsSessionId");
                for (let index = 0; index < integrator.pacsSessions.length; index++) {
                    const pacsSession = integrator.pacsSessions[index];
                    const pacsBaseUrl = pacsSession.baseUrl || '';
                    const response = yield closeSessionAPI(pacsBaseUrl, pacsSession.risUser.userName, pacsSession.pacsSessionId);
                }
            }
        }
    } catch (error) {
        yield put({ type: CLOSE_SESSION_ERROR, error })
        message.error('Failed to close session!');
    }
}

function* integratorWatcher() {
    yield takeLatest(FETCH_PACS, fetchPacsList)
    yield takeLatest(FETCH_INTEGRATOR, fetchIntegrator)
    yield takeLatest(GENERATE_SESSIONID, generateSessionId)
    yield takeLatest(LOAD_ORDER, loadOrder)
    yield takeLatest(UNLOAD_ORDER, unloadOrder)
    yield takeLatest(CLOSE_SESSION, closeSession)
}

export default function* rootSaga() {
    yield all([
        integratorWatcher(),
    ]);
}